<template>
    <div id="footer">
        <div class="container">
            <slot></slot>
        </div>
    </div>
</template>

<script>
    export default {
        name:'foot',
        props:{
            text:{type:String}
        }
    }
</script>

<style scoped>
    #footer{
        height:100px; 
        background:#dedede;
        padding: 0px 150px;
    }
    #footer p{
        font-size: 0.75rem;
        padding-top: 15px;
        text-align: right;
    }

     #footer{
        height:100px;  
        padding: 0px 150px;
    }
    #footer p{
        text-align: right;
    }


    @media (max-width:768px){
        #footer{
            height:100px;  
            padding: 0px 100px !important;
        }
        #footer p{
            text-align: center !important;
        }
    }
    @media (max-width:576px){
        #footer{
            height:100px;  
            padding: 0px 50px !important;
        }
        #footer p{
            text-align: center !important;
        }
    }
</style>





// WEBPACK FOOTER //
// src/components/overall_layouts/footer.vue